import React from 'react';
import { StarIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';

import { CoursePrice, ICourse, SaveCourse } from 'modules/courses';
import { globalConst, TimeAgo } from 'modules/global';

interface IProps {
  course?: ICourse;
}

const CourseCard: React.FC<IProps> = ({ course }) => (
    <Link
      href={`${globalConst?.pageNames?.COURSES}/${course?.slug}`}
      className="block rounded-lg border border-gray-100 p-2"
    >
      <div className="md:h-15 h-18 flex items-start gap-2">
        <div>
          {course?.image ? (
            <div className="w-27.5 h-15 relative">
              <Image
                fill
                alt={course?.name || 'Course Image'}
                title="Kursni tasvirlovchi rasm"
                className="rounded-xl object-cover"
                src={course?.image?.small || '/images/no-image.webp'}
              />
            </div>
          ) : (
            <div className="h-15 w-27.5 flex items-center justify-center rounded-xl bg-gray-50">
              <Image
                alt={course?.name || 'Course Image'}
                src="/images/default-no-image.webp"
                height={30}
                width={30}
                title="Kursni tasvirlovchi rasm"
              />
            </div>
          )}
        </div>
        <div className="flex h-full flex-1 flex-col justify-between">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-1">
              <div className="flex min-h-7 min-w-7 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-50 text-xs">
                <Image
                  src={course?.teacher?.image?.small || '/images/default-no-logo.webp'}
                  alt={course?.teacher?.full_name?.slice(0, 1) || 'user profile avatar'}
                  width={course?.teacher?.image?.small ? 27 : 15}
                  height={course?.teacher?.image?.small ? 27 : 15}
                  className="object-contain "
                  title="Kurs ishlab chiquvchining rasmi"
                />
              </div>
              <div className="flex flex-col">
                <span className="line-clamp-2 text-xs font-medium">{course?.name}</span>
                <Link
                  href={`${globalConst?.pageNames?.TEACHER}/${course?.teacher?.slug}`}
                  className="line-clamp-1 text-[0.625rem] text-gray-500 hover:text-green-500"
                >
                  {course?.teacher?.full_name}
                </Link>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1 text-sm">
                <span>
                  <StarIcon color="text-yellow-300" size="14" />
                </span>
                {course?.rating}
              </div>
              <SaveCourse isSaved={course?.is_saved as boolean} courseId={course?.id as number} />
            </div>
          </div>

          <div className="flex items-end justify-between">
            <span className="text-[0.625rem] text-gray-500">{TimeAgo(course?.created_at)}</span>
            <CoursePrice
              discountPercent={course?.discount_percent}
              isFree={course?.type === 'free'}
              price={course?.price}
            />
          </div>
        </div>
      </div>
    </Link>
  );

export default CourseCard;
